import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { uploadPhoto } from './actions';

export interface PhotoUploadState {
    photos: PhotoUploadItem[];
}

export interface PhotoUploadItem {
    url: string;
    id: string;
    isLoaded: boolean;
}

const initialState = {
    photos: [],
} as PhotoUploadState;

const uploadSlice = createSlice({
    name: 'upload',
    initialState,
    reducers: {
        uploadLocalPhoto: (state, action: PayloadAction<string>) => {
            state.photos.push({
                url: action.payload,
                id: String(state.photos.length),
                isLoaded: false,
            });
        },
        uploadLocalPhotosWithReplacing: (state, action: PayloadAction<PhotoUploadItem[]>) => {
            state.photos = action.payload;
        },
        clearUploadedPhotos: () => initialState,
        deletePhoto: (state, action: PayloadAction<string>) => {
            state.photos = state.photos.filter((item) => item.id !== action.payload);
        },
    },
    extraReducers: (builder) => {
        builder.addCase(uploadPhoto.fulfilled, (state, action) => {
            const { id, url } = action.payload;
            const newPhoto = {
                id,
                url,
                isLoaded: true,
            };
            state.photos = state.photos.map((item) => (item.id === String(state.photos.length - 1) ? newPhoto : item));
        });
        builder.addCase(uploadPhoto.rejected, (state) => {
            state.photos = state.photos.map((item) =>
                item.id === String(state.photos.length - 1) ? { id: item.id, url: item.url, isLoaded: true } : item,
            );
        });
    },
});

export default uploadSlice.reducer;
export const { uploadLocalPhoto, uploadLocalPhotosWithReplacing, clearUploadedPhotos, deletePhoto } =
    uploadSlice.actions;
